firebird.factory('videoLayoutLockService', [
    '$rootScope',
    '$window',
    'logService',
    'socketService',
    'attendeeListService',
    'helperService',
    'configService',
    'videoGlobalService',
    function (
        $rootScope,
        $window,
        logService,
        socketService,
        attendeeListService,
        helperService,
        configService,
        videoGlobalService
    ) {
        const logger = logService.createLoggerWithSource('videoLayoutLockService');
        var service = {
            initialize: initialize
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // whether the layout lock is "available", "locked" or null (unavailable). Modify in user pair.
            self.layoutLock = null;
            // list of stream id values, and spotlight if any, and other layout data. Useful only if layout is locked.
            // new attributes: total and visible, are added for layoutPage case.
            self.layoutLockData = { ratio: 16 / 9, method: null, spotlight: null, items: [] };

            self.initLayoutLock = initLayoutLock;

            self.onUpdateVideosLayout = onUpdateVideosLayout;
            self.onFetchVideosLayout = onFetchVideosLayout;
            self.setLayoutLock = setLayoutLock;
            self.getHostAttendantId = getHostAttendantId;
            self.updateLockedSpotlight = updateLockedSpotlight;

            // when used together with layoutLock == 'locked'
            self.onLayoutPageUpdateLockData = onLayoutPageUpdateLockData;
            self.onLayoutPageUpdateLockPositions = onLayoutPageUpdateLockPositions;
        }

        // update from config.
        function initLayoutLock() {
            // layout lock, from user pair, but not from url param.
            self.setLayoutLock();
        }

        // set layoutLock to null or "locked" or "available" from user pair, not URL param. default is 'available'
        function setLayoutLock(no_request) {
            var value = configService.getServerValue('layoutLock') || 'available';
            self.layoutLock = value && value != 'false' ? (value == 'true' ? 'locked' : value) : null;
            if (self.layoutLock) {
                logger.log('videoroomCtrl - layoutLock = ' + self.layoutLock);
            }

            if (self.layoutLock == 'locked') {
                $window.$('#videoroom-videos').attr('layoutlock', 'true');
            } else {
                $window.$('#videoroom-videos').removeAttr('layoutlock');
            }

            if (!no_request && self.layoutLock == 'locked' && !self.isHost) {
                // fetch the layout from host
                var hostId = self.getHostAttendantId();
                logger.log('videoroomCtrl - sending fetch-videos-layout to ' + hostId);
                if (hostId) {
                    socketService.send({
                        message: 'attendee-message',
                        data: { type: 'fetch-videos-layout', to: hostId }
                    });
                }
            }

            if (self.layoutLock == 'locked') {
                if (self.screenshare && self.screenshareOwner == self.attendantId && !self.fileplay) {
                    self.startVideoPlay(self.screenshareOwner, true, true);
                    self.setScreenDisplay(true);
                }
            } else if (self.layoutLock == 'available') {
                if (self.screenshare && self.screenshareOwner == self.attendantId) {
                    self.stopVideoPlay(self.screenshareOwner, true, false);
                    self.setScreenDisplay(false);
                }
            }
        }

        // get the attendant ID of the host, if present in the attendee list.
        // this should be moved to attendeeListService if has wider usage, after fakeHost dependency is removed.
        function getHostAttendantId() {
            var fakeHost =
                (helperService.getLocationHost() == 'localhost' && helperService.getQueryParameter('fakeHost')) || null;
            if ((!fakeHost && self.isHost) || fakeHost == 'true') {
                return self.attendantId;
            }

            var list = attendeeListService.getAttendeeList();
            if (list) {
                list.forEach(function (attendee) {
                    if (
                        attendee &&
                        ((!fakeHost && attendee.attendeeType == 'host') ||
                            (fakeHost && attendee.attendantId == fakeHost))
                    ) {
                        return attendee.attendantId;
                    }
                });
            }
            return null;
        }

        // process fetch-videos-layout from non-host attendee to this host attendee, by responding with
        // update-videos-layout only if the layout is currently locked.
        function onFetchVideosLayout(from) {
            if (self.isHost && self.layoutLock == 'locked' && from != self.attendantId) {
                logger.log('videoroomCtrl sending update-videos-layout to one attendee: ' + from);
                socketService.send({
                    message: 'attendee-message',
                    data: { type: 'update-videos-layout', to: from, data: self.layoutLockData }
                });
            }
        }

        // update spotlight view for locked layout
        function updateLockedSpotlight() {
            var data = self.layoutLockData;

            if (data.spotlight && (!self.maxvideo || self.maxvideo.getAttribute('user') != data.spotlight)) {
                var maxvideo = $window.$('#videoroom-videos > div[user="' + data.spotlight + '"]');
                if (maxvideo.length > 0) {
                    self.setSpotlightVideo(maxvideo.get(0));
                }
            } else if (!data.spotlight && self.maxvideo) {
                self.setSpotlightVideo(null); // TODO: switch to allhands if host was allhands.
            }
        }

        // received update-videos-layout. adjust local videos layout based on received data.
        function onUpdateVideosLayout(data) {
            if (self.layoutLock == 'locked' && !self.isHost) {
                self.layoutLockData = data;
                self.layoutMethod = data.method;

                self.updateLockedSpotlight();

                if (!self.layoutPage) {
                    // this code should not be run for layoutPage.
                    var children = [].slice.call($window.$('#videoroom-videos > div[enable="true"]:not(.audioonly)'));
                    var existing = children.map(function (div) {
                        return div.getAttribute('user');
                    });
                    var updated = data.items.slice();

                    // change local videos order in the same order as updated. only if same values found
                    var run = existing.length * 2; // max run to avoid infinite loop
                    if (existing.length == updated.length && existing.length > 0) {
                        while (run-- > 0) {
                            var first = -1; // first difference
                            for (var i = 0; i < existing.length; ++i) {
                                if (existing[i] != updated[i]) {
                                    first = i;
                                    break;
                                }
                            }
                            if (first < 0) {
                                // both are same.
                                break;
                            }
                            // the updated[i] must be present in existing[i], after i
                            var j = existing.indexOf(updated[i]);
                            if (j < 0 || j <= i) {
                                // otherwise, if not present or before i, do not do anything
                                break;
                            }
                            // move item at j to position i.
                            // use console.info to avoid log entries, but display locally for debugging.
                            console.info('moving ' + j + ' to ' + i);
                            console.info(children[j], children[i]);
                            // do not use jquery, to avoid unnecessary checks.
                            $window.$('#videoroom-videos')[0].insertBefore(children[j], children[i]);
                        }
                    }
                }

                self.updateVideosLayout();
            }
        }

        // when host sends layout to this, update local.
        function onLayoutPageUpdateLockPositions() {
            if (self.layoutLock == 'locked' && !self.isHost && self.layoutLockData && self.layoutLockData.positions) {
                if (self.layoutLockData.total !== undefined) {
                    $window.$('#videoroom-videos').attr('total', self.layoutLockData.total);
                }
                if (self.layoutLockData.visible !== undefined) {
                    $window.$('#videoroom-videos').attr('visible', self.layoutLockData.visible);
                    $window.$('#videoroom').attr('visible', !!self.layoutLockData.visible);
                    try {
                        // has exception (in angular: $$nextSibling of null) sometimes, when meeting ends.
                        var visible = parseInt(self.layoutLockData.visible);
                        $rootScope.$broadcast('video-room-webcams-visible', !!visible);
                    } catch (e) {
                        // ignore the exception
                    }
                }

                var positions = self.layoutLockData.positions || [];

                var dict = {};
                positions.forEach(function (item) {
                    dict[item.fid] = item;
                });

                var divs = [].slice.call($window.$('#videoroom-videos > div[user]:not(.audioonly)'));
                var W = $window.$('#videoroom-videos').get(0).offsetWidth,
                    H = $window.$('#videoroom-videos').get(0).offsetHeight;
                var round = function (value) {
                    return Math.round(value * 10) / 10;
                };

                var ratio = self.layoutLockData.ratio;
                var x1 = 0,
                    y1 = 0,
                    H1 = H,
                    W1 = W;
                if (W / H >= ratio) {
                    x1 = W / 2 - (H * ratio) / 2;
                    W1 = H * ratio;
                } else {
                    y1 = H / 2 - W / (2 * ratio);
                    H1 = W / ratio;
                }

                divs.forEach(function (div) {
                    var fid = div.getAttribute('user');
                    var oldValue = div.getAttribute('enable') == 'true';
                    var value = !!dict[fid];
                    if (value) {
                        var item = dict[fid];
                        div.setAttribute('enable', 'true');
                        div.style.display = 'block';
                        div.style.visibility = 'visible';
                        div.style.left = round((item.x * W1) / 1280 + x1) + 'px';
                        div.style.top = round((item.y * H1) / 720 + y1) + 'px';
                        div.style.width = round((item.w * W1) / 1280) + 'px';
                        div.style.height = round((item.h * H1) / 720) + 'px';
                    } else {
                        div.setAttribute('enable', 'false');
                        div.setAttribute(
                            'style',
                            'left: 0px; top: 0px; width: 0px; height: 0px; display: none; visibility: hidden;'
                        );
                    }

                    if (oldValue !== value && div && div.remoteFeed) {
                        self.pauseVideoPlay(div.remoteFeed, !value);
                        if (value) {
                            delete div.remoteFeed.layoutHidden;
                        } else {
                            div.remoteFeed.layoutHidden = true;
                        }
                    }
                });
                return true;
            }
            return false;
        }

        // after host video layout is updated, send to others.
        function onLayoutPageUpdateLockData() {
            if (self.layoutLock == 'locked' && self.isHost) {
                // since layoutPage uses positions, always send positions.
                if (self.layoutPage) {
                    self.layoutLockData.layout = self.layoutPageData.layout; // presence indicates new algorithm
                    var W = $('#videoroom-videos').get(0).offsetWidth,
                        H = $('#videoroom-videos').get(0).offsetHeight;
                    var round = function (value) {
                        return Math.round(value * 10) / 10;
                    };

                    var ratio = self.layoutLockData.ratio;
                    var x1 = 0,
                        y1 = 0,
                        H1 = H,
                        W1 = W;
                    if (W / H >= ratio) {
                        x1 = W / 2 - (H * ratio) / 2;
                        W1 = H * ratio;
                    } else {
                        y1 = H / 2 - W / (2 * ratio);
                        H1 = W / ratio;
                    }

                    var children = [].slice.call($window.$('#videoroom-videos > div[enable="true"]:not(.audioonly)'));
                    self.layoutLockData.positions = children.map(function (div) {
                        var item = { fid: div.getAttribute('user') };
                        // do not use offsetLeft,Top,Width,Height - as animation delays their updates.
                        item.x = round(((parseFloat(div.style.left) - x1) * 1280) / W1);
                        item.y = round(((parseFloat(div.style.top) - y1) * 720) / H1);
                        item.w = round((parseFloat(div.style.width) * 1280) / W1);
                        item.h = round((parseFloat(div.style.height) * 720) / H1);
                        return item;
                    });

                    self.layoutLockData.total = $window.$('#videoroom-videos').attr('total');
                    self.layoutLockData.visible = $window.$('#videoroom-videos').attr('visible');
                } else {
                    if (self.layoutLockData.positions) {
                        delete self.layoutLockData.positions;
                    }
                    if (self.layoutLockData.total !== undefined) {
                        delete self.layoutLockData.total;
                    }
                    if (self.layoutLockData.visible !== undefined) {
                        delete self.layoutLockData.visible;
                    }
                }

                if (self.hasTestLayout) {
                    self.layoutLockData.testlayout = true;
                } else if (self.layoutLockData.testlayout) {
                    delete self.layoutLockData.testlayout;
                }
            }
        }
    }
]);
